export default {
  homepage: "主页"
};



// WEBPACK FOOTER //
// ./src/common/lang/zh.js